import React, { useEffect, useState, useCallback } from "react";

import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";

// Formik Validation
import { useFormik } from "formik";
import * as Yup from "yup";

//redux
import { useDispatch, useSelector } from "react-redux";

// actions
import { useNavigate } from "react-router-dom";
import { createSelector } from "reselect";
import { userChangePassword } from "slices/auth/changepwd/thunk";
import { resetChangePasswordState } from "slices/auth/changepwd/reducer";
import { showSuccessToast, showErrorToast } from "../../helpers/toast_helper";
import { RootState } from "store";

interface ChangePasswordModalProps {
  show: boolean;
  onCloseClick: () => void;
}

const ChangePassword: React.FC<ChangePasswordModalProps> = ({
  show,
  onCloseClick,
}) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);

  const navigate = useNavigate();

  const selectLayoutState = (state: any) => state;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    changePasswordError: state.ChangePassword.changePasswordError,
    changePwdSuccessMsg: state.ChangePassword.changePwdSuccessMsg,
  }));
  // Inside your component
  const { changePasswordError, changePwdSuccessMsg } = useSelector(
    selectLayoutProperties
  );

  const selectLoginState = (state: RootState)=>state.Login
  const selectUserData = createSelector(
    selectLoginState,(login)=>({
      user:login.user,
      error:login.error
    })
  )
  const {user} = useSelector(selectUserData)

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&^_-])[A-Za-z\d@$!%*#?&^_-]{8,}$/

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      old_password: "",
      new_password: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string().trim().required("Please enter your current password"),
      new_password: Yup.string()
        .trim()
        .required("Please enter a new password")
        .matches(
          passwordRegex,
          "Password must be at least 8 characters and include uppercase, lowercase, number, and special character"
        ),

    }),
    onSubmit: (values, { resetForm }) => {
      dispatch(userChangePassword({ ...values,}, navigate));
      // setLoader(true)
      resetForm();
    },
  });

  const handleModalClose = useCallback((): void => {
    dispatch(resetChangePasswordState());
    if (validation) {
      validation.resetForm();
    }
    onCloseClick();
  }, [dispatch, validation, onCloseClick]);

  // Only run this useEffect when modal is open
  useEffect(() => {
    if (!show) return; // Exit early if modal is not open
    
    if (changePwdSuccessMsg) {
      console.log('change password success msg....', changePwdSuccessMsg);
      showSuccessToast(changePwdSuccessMsg, "change-password-success");
      setLoader(false)
      handleModalClose();
    }
  }, [show, changePwdSuccessMsg, handleModalClose]);


  // Only run this useEffect when modal is open
  useEffect(() => {
    if (!show) return; // Exit early if modal is not open
    
    if (changePasswordError) {
      showErrorToast(changePasswordError, "change-password-error");
      setLoader(false);
      dispatch(resetChangePasswordState());
    }
  }, [show, changePasswordError, dispatch]);

  document.title = "Amanat | Amanat - Admin & Dashboard";
  return (
     <>
   {/* <ToastContainer autoClose={3000} limit={1} /> */}
    <Modal fade={true} isOpen={show} toggle={handleModalClose} centered={true}>
      <ModalHeader toggle={handleModalClose}>Change Password</ModalHeader>
      <ModalBody> 
        <Row>
          <Col lg="12">
            {changePasswordError && changePasswordError ? (
              <Alert color="danger">{changePasswordError.message || "Something went wrong"}</Alert>
            ) : null}
            {changePwdSuccessMsg ? (
              <Alert color="success">Password updated Successfully</Alert>
            ) : null}
          </Col>
        </Row>
        <Card>
          <CardBody>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="form-group">
                <Label className="form-label mt-1">Current Password</Label>
                <Input
                  name="old_password"
                  // value={name}
                  className="form-control"
                  placeholder="Enter Current Password"
                  type="password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.old_password}
                  invalid={
                    validation.touched.old_password &&
                      validation.errors.old_password
                      ? true
                      : false
                  }
                />
                {validation.touched.old_password &&
                  validation.errors.old_password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.old_password}
                  </FormFeedback>
                ) : null}
                <Label className="form-label mt-2">New Password</Label>
                <Input
                  name="new_password"
                  // value={name}
                  className="form-control mb-2"
                  placeholder="Enter New Password"
                  type="password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.new_password}
                  invalid={
                    validation.touched.new_password &&
                      validation.errors.new_password
                      ? true
                      : false
                  }
                />
                {validation.touched.new_password &&
                  validation.errors.new_password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.new_password}
                  </FormFeedback>
                ) : null}
                {/* <Input name="idx" value={idx} type="hidden" /> */}
              </div>
              <div className="text-center mt-4">
                <Button className="btn btn-primary w-100" type="submit" color="primary" disabled={loader && true}>
                    {loader && (
                      <Spinner size="sm" className="me-2">
                        {" "}
                        Loading...{" "}
                      </Spinner>
                    )}
                  Update Password
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
    </>
  );
};

export default ChangePassword;
